import { DecoratorNode } from "lexical";
import React from "react";

export const INSERT_IMAGE_COMMAND = "INSERT_IMAGE_COMMAND";

export class ImageNode extends DecoratorNode {
  static getType() {
    return "image";
  }

  static clone(node) {
    return new ImageNode(node.__src, node.__key);
  }

  static isInline() {
    return false;
  }

  constructor(src, key) {
    super(key);
    this.__src = src;
  }

  // Required so Lexical can store + restore the node
  static importJSON(serializedNode) {
    const { src } = serializedNode;
    return new ImageNode(src);
  }

  exportJSON() {
    return {
      type: "image",
      version: 1,
      src: this.__src
    };
  }

  exportDOM() {
    const img = document.createElement("img");
    img.src = this.__src;
    img.style.maxWidth = "100%";
    img.style.margin = "20px 0";
    img.style.display = "block";
    return { element: img };
  }

  // REQUIRED for Lexical: Creates the DOM anchor for the decorator
  createDOM() {
    const dom = document.createElement("span");
    return dom;
  }

  // REQUIRED: Tell Lexical whether to re-render
  updateDOM() {
    return false;
  }

  // Required for Lexical editor rendering
  decorate() {
    return (
      <img
        src={this.__src}
        style={{
          maxWidth: "100%",
          margin: "20px 0",
          display: "block"
        }}
      />
    );
  }
}

export function $createImageNode(src) {
  return new ImageNode(src);
}

/*
import { DecoratorNode } from "lexical";

export const INSERT_IMAGE_COMMAND = "INSERT_IMAGE_COMMAND";

export class ImageNode extends DecoratorNode {
  static getType() {
    return "image";
  }

  static clone(node) {
    return new ImageNode(node.__src, node.__key);
  }

  constructor(src, key) {
    super(key);
    this.__src = src;
  }

  createDOM() {
    const img = document.createElement("img");
    img.src = this.__src;
    img.style.maxWidth = "100%";
    img.style.margin = "20px 0";
    return img;
  }

  updateDOM() {
    return false;
  }
}

export function $createImageNode({ src }) {
  return new ImageNode(src);
}
*/